module.exports = __webpack_public_path__ + "static/media/layers.7bd4516c.svg";